// @ts-nocheck

import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';

export const infoButtonCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.6em;
  height: 1.6em;
  min-width: 1.6em;
  min-height: 1.6em;
  line-height: 1.6;
  text-decoration: none;
  border-radius: 50%;
  border: solid 1px ${({ theme }) => theme.grids.colors.middlegrey1};
  background: none;
  text-align: center;
  margin-left: 0.2em;

  && {
    color: ${({ theme }) => theme.grids.colors.middlegrey3};
  }

  ${Target.__MOBILE__
    ? undefined
    : css`
        &&&:hover {
          color: #fff;
          border-color: #fff;
        }
      `}
`;

const InfoButton = styled(Link)`
  ${infoButtonCss}
`;

export default InfoButton;
